import * as React from "react";

const Warning: React.FC = () => {
    return <svg width="24px" height="21px" viewBox="0 0 24 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-681.000000, -415.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(602.000000, 185.000000)">
                    <path d="M12,3.02334666 L2.58476952,19.5 L21.4152305,19.5 L12,3.02334666 Z M12,0 L24,21 L0,21 L12,0 Z"></path>
                    <polygon points="11.2 8.4 11.2 10 11.6 14 12.4 14 12.8 10 12.8 8.4"></polygon>
                    <circle cx="12" cy="16" r="1"></circle>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Warning);
